<template>
  <div class="about-us w">
    <div class="search">
      <!-- 年龄筛选 -->
      <div style="display: flex;align-items: center;">
        <div style="width: 5%;">年龄</div>
        <div class="filter-group" style="width: 90%;">
          <!-- <span class="filter-label">年龄</span> -->
          <div v-for="item in ageOptions" :key="item.id" :class="['filter-item', { active: selectedAge.id === item.id }]"
            @click="handleAgeClick(item)">
            {{ item.category_name }}
          </div>
        </div>
      </div>
      <!-- 年份子筛选 -->
      <div v-if="showYearSubFilter" class="sub-filter-group">
        <div v-for="year in currentYears" :key="year.id"
          :class="['sub-filter-item', { 'sub-active': selectedYear === year.id }]" @click="handleYearClick(year.id)">
          {{ year.category_name }}
        </div>
      </div>

      <!-- 性别筛选 -->
      <div style="display: flex;align-items: center;">
        <div style="width: 5%;">性别</div>
        <div class="filter-group" style="margin: 20px 0;">
          <!-- <span class="filter-label">性别</span> -->
          <div v-for="item in genderOptions" :key="item.id"
            :class="['filter-item', { active: selectedGender === item.id }]" @click="handleGenderClick(item.id)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <!-- 籍贯 -->
      <div style="display: flex;align-items: center;">
        <div style="width: 5%;">籍贯</div>
        <div class="filter-group" style="width: 90%;">
          <!-- <span class="filter-label">籍贯</span> -->
          <div v-for="(province, index) in showProvinceList" :key="province.id"
            :class="['filter-item', { active: selectedProvince === province.id }]" @click="handleProvinceClick(province)">
            {{ province.name }}
          </div>
        </div>
        <div class="filter-item expand-btn" @click="isProvinceExpanded = !isProvinceExpanded">
          {{ isProvinceExpanded ? '收起' : '展开' }}
          <i :class="['el-icon', isProvinceExpanded ? 'el-icon-caret-top' : 'el-icon-caret-bottom']"></i>
        </div>
      </div>
      <!-- 城市子筛选 -->
      <div v-if="showCitySubFilter" class="sub-filter-group">
        <div v-for="city in currentCities" :key="city.id"
          :class="['sub-filter-item', { 'sub-active': selectedCity === city.id }]" @click="handleCityClick(city.id)">
          {{ city.name }}
        </div>
      </div>
    </div>

    <div class="total-count">
      共{{ total }}位艺人
    </div>

    <!-- 数据展示区域 -->
    <div v-if="showData" class="result-area">
      <div v-for="(item, index) in resultList" :key="index" class="artist-item" @click="handleItemClick(item.id)">
        <img class="img"
          :src="item.photo.length > 0 ? item.photo[0].pic : 'https://www.nidexiaoxiang.com/upload/image/20250322/6ef734fcf3eaa0d1b5f554a074ddbf64.png'"
          alt="">
        <div class="name">{{ item.prodname }}</div>
        <div class="info">{{ item.height }}/{{ item.birthday }}</div>
      </div>
    </div>

    <div class="pages-about">
      <el-pagination background layout="prev, pager, next" :total="total" :current-page="page" :page-size="pageSize"
        @current-change="handlePageChange" class="custom-pagination"></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutUs",
  data() {
    return {
      // 年龄筛选选项
      ageOptions: [],

      // 性别选项
      genderOptions: [
        { id: '', label: '全部' },
        { id: '1', label: '男' },
        { id: '2', label: '女' }
      ],

      // 籍贯数据
      provinceOptions: [],

      // 状态管理
      selectedAge: this.$store.state.condition.selectedAge || { id: this.$route.query.id ? this.$route.query.id : '', child: [] },
      selectedYear: this.$store.state.condition.selectedYear || '',
      selectedGender: this.$store.state.condition.selectedGender || '',
      selectedProvince: this.$store.state.condition.selectedProvince || '',
      selectedCity: this.$store.state.condition.selectedCity || '',
      page: this.$store.state.condition.page || 1,
      currentCities: [],

      // 数据相关
      resultList: [],
      showData: true,
      pageSize: 50,
      total: 0,
      searchKeyword: '',
      isProvinceExpanded: false,
      defaultShowCount: 10
    };
  },
  computed: {
    showYearSubFilter() {
      return this.selectedAge.child.length > 0
    },
    currentYears() {
      return this.selectedAge.child
    },
    showCitySubFilter() {
      return this.currentCities.length > 0
    },
    showProvinceList() {
    return this.isProvinceExpanded 
      ? this.provinceOptions
      : this.provinceOptions.slice(0, this.defaultShowCount)
  }
  },

  mounted() {
    this.searchKeyword = this.$route.query.keyword || ''
    this.getAge()
    this.getCity()
    const savedCondition = this.$store.state.condition;
    if (savedCondition) {
      if (savedCondition.selectedAge) {
        this.selectedAge = savedCondition.selectedAge;
      }
      if (savedCondition.selectedYear !== undefined) {
        this.selectedYear = savedCondition.selectedYear;
      }
      if (savedCondition.selectedGender !== undefined) {
        this.selectedGender = savedCondition.selectedGender;
      }
      if (savedCondition.selectedProvince !== undefined) {
        this.selectedProvince = savedCondition.selectedProvince;
        if (this.selectedProvince) {
          const province = this.provinceOptions.find(p => p.id === this.selectedProvince);
          if (province) {
            this.currentCities = province.child;
          }
        }
      }
      if (savedCondition.selectedCity !== undefined) {
        this.selectedCity = savedCondition.selectedCity;
      }
      if (savedCondition.page) {
        this.page = savedCondition.page;
      }
    }

    // this.fetchData() //页面数据
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        // 强制触发数据更新逻辑
        this.searchKeyword = newQuery.keyword || ''
        // this.page = 1
        this.fetchData()
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 获取年龄年份
    getAge() {
      this.$http.get('/api/index/getagelist')
        .then(res => {
          if (res.status == 200) {
            // 1. 添加最外层"全部"选项
            const processedData = [
              {
                id: '',
                category_name: '全部',
                child: []
              },
              ...res.data.data
            ]

            // 2. 给每个有子项的节点添加"全部"选项
            processedData.forEach(ageGroup => {
              if (ageGroup.child && ageGroup.child.length > 0) {
                ageGroup.child.unshift({
                  id: '',
                  category_name: '全部',
                  child: []
                })
              }
            })

            // 3. 映射成前端需要的结构
            this.ageOptions = processedData.map(item => ({
              id: item.id,
              category_name: item.category_name,
              child: item.child.map(child => ({
                id: child.id,
                category_name: child.category_name
              }))
            }))
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            })
          }
        })
    },
    // 获取籍贯
    getCity() {
      this.$http.get(`/api/index/getcitylist?pid=${0}`)
        .then(res => {
          if (res.status == 200) {
            // 1. 添加最外层"全部"选项
            const processedData = [
              {
                id: '',
                name: '全部',
                child: []
              },
              ...res.data.data
            ]

            // 2. 给每个有子项的节点添加"全部"选项
            processedData.forEach(ageGroup => {
              if (ageGroup.child && ageGroup.child.length > 0) {
                ageGroup.child.unshift({
                  id: '',
                  name: '全部',
                  child: []
                })
              }
            })

            // 3. 映射成前端需要的结构
            this.provinceOptions = processedData.map(item => ({
              id: item.id,
              name: item.name,
              child: item.child.map(child => ({
                id: child.id,
                name: child.name
              }))
            }))
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            })
          }
        })
    },
    // 年龄筛选
    handleAgeClick(item) {
      this.selectedAge = item
      this.page = 1
      this.selectedYear = ''
      this.fetchData()
    },

    // 年份筛选
    handleYearClick(year) {
      this.selectedYear = year
      this.page = 1
      this.fetchData()
    },

    // 性别筛选
    handleGenderClick(id) {
      this.selectedGender = id
      this.page = 1
      this.fetchData()
    },

    // 省份筛选
    handleProvinceClick(province) {
      this.selectedProvince = province.id
      this.selectedCity = ''
      this.currentCities = province.child // 直接获取当前省份的城市列表
      this.page = 1
      this.fetchData()
    },

    // 城市筛选
    handleCityClick(cityId) {
      this.selectedCity = cityId
      this.page = 1
      this.fetchData()
    },

    // 分页处理
    handlePageChange(val) {
      this.page = val
      this.fetchData()
    },

    // 获取数据（模拟）
    async fetchData() {
      try {
        const params = {
          ageid: this.selectedAge.id,
          year: this.selectedYear,
          sex: this.selectedGender,
          cityid: this.selectedCity,
          provid: this.selectedProvince,
          page: this.page,
          pagesize: this.pageSize,
          keyword: this.searchKeyword
        }
        const res = await this.$http.get('/api/index/getartistlist', { params })
        this.resultList = res.data.data.data
        this.total = Number(res.data.data.total)
      } catch (error) {
        this.showData = false
      }
    },

    // 查看详情
    handleItemClick(id) {
      this.$store.commit('SAVE_SAVE_CONDITION', {
        selectedAge: this.selectedAge,
        selectedYear: this.selectedYear,
        selectedGender: this.selectedGender,
        selectedProvince: this.selectedProvince,
        selectedCity: this.selectedCity,
        page: this.page
      });
      this.$router.push({ name: "contactUs", query: { id } });
    },

    // 全部城市页面
    // allCity() {
    //   this.$router.push({ name: 'allCity' })
    // }
  }
}
</script>

<style lang="scss" scoped>
.about-us {
  .search {
    margin: 30px 0;
    padding: 30px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
  }
  .filter-group {
  position: relative;
  display: flex;
  align-items: center;

  // 展开按钮样式
  .expand-btn {
    position: sticky;
    right: 0;
    background: linear-gradient(90deg, rgba(255,255,255,0) 0%, #fff 20%);
    padding-left: 20px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    
    .el-icon {
      margin-left: 5px;
      font-size: 14px;
    }
  }
}

// 展开状态下的样式
.filter-group.expanded {
  flex-wrap: wrap;
  overflow-x: visible;
}

  .filter-group {
    position: relative;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px 20px;

    .filter-label {
      color: #999;
      margin-right: 15px;
      min-width: 50px;
    }

    .filter-item {
      padding: 4px 8px;
      cursor: pointer;
      color: #666;
      transition: all 0.2s;
      position: relative;

      &.active {
        color: #333;
        font-weight: 700;

        // &::after {
        //   content: '';
        //   position: absolute;
        //   bottom: -5px;
        //   left: 50%;
        //   transform: translateX(-50%);
        //   width: 60%;
        //   height: 2px;
        //   background: #333;
        // }
      }

      &:hover {
        color: #333;
      }
    }

    .all-city {
      margin-left: auto;
      padding: 6px 16px;
      border: 1px solid #ddd;
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.2s;

      &:hover {
        border-color: #666;
      }
    }
  }

  .sub-filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px 30px;
    padding: 12px 24px;
    margin: 10px 0 0 92px;
    background: #f5f5f5;
    border-radius: 4px;

    .sub-filter-item {
      padding: 4px 8px;
      cursor: pointer;
      color: #666;
      transition: all 0.2s;
      white-space: nowrap;

      // &:hover {
      //   color: #333;
      //   background: #eee;
      // }

      &.sub-active {
        color: #333;
        font-weight: 700;
        // background: #e0e0e0;
        // border-radius: 3px;
      }
    }
  }

  .result-area {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 30px 20px;
    margin-top: 30px;

    .artist-item {
      background: #f9f9f9;
      border-radius: 10px 10px 0 0;
      overflow: hidden;
      cursor: pointer;
      text-align: center;
      // transition: transform 0.2s;

      // &:hover {
      //   transform: translateY(-5px);
      // }

      .img {
        width: 100%;
        height: 320px;
        object-fit: cover;
      }

      .name {
        font-size: 18px;
        font-weight: 600;
        margin: 15px 0 8px;
        padding: 0 12px;
      }

      .info {
        color: #666;
        font-size: 14px;
        padding: 0 12px 15px;
      }
    }
  }

  .pages-about {
    padding: 50px 0;
    display: flex;
    justify-content: center;
  }

  .total-count {
    margin: 20px 0;
    font-size: 16px;
    color: #666;
  }
}
</style>